import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { LocaleProvider } from './contexts/LocaleContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import ErrorBoundary from './components/ErrorBoundary';
import LoginPage from './pages/LoginPage';
import ConsolePage from './pages/ConsolePage';
import './styles/ui-tokens.css';
import './App.css';

function LoginRedirect() {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', color: '#94a3b8' }}>
        Loading…
      </div>
    );
  }
  return user ? <Navigate to="/" replace /> : <LoginPage />;
}

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <LocaleProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<LoginRedirect />} />
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <ErrorBoundary>
                      <ConsolePage />
                    </ErrorBoundary>
                  </ProtectedRoute>
                }
              />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </LocaleProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
